import React, { useState } from 'react';
import { Button } from '../../ui/ot';
import axios from 'axios';

const ExportExcelButton = ({
    apiPath = '/koha/report/item/excel',
    fileName = 'export.xlsx',
    excelType = 'withdrawn',
    params = {},
    buttonText = '匯出檔案',
    buttonStyle = {
        color: "#fff",
        backgroundColor: "#56b673"
    },
}) => {
    const [loading, setLoading] = useState(false);

    const handleExport = async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiPath, {
                responseType: 'blob',
                params: {
                    ...params,
                    excel_type: excelType,
                },
            });

            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('匯出失敗:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            type="text"
            style={buttonStyle}
            loading={loading}
            onClick={handleExport}
        >
            {buttonText}
        </Button>
    );
};

export default ExportExcelButton;
